<app-header [label]="page_name"></app-header>
<div class="flex bg-white gap-4 items-center justify-between p-4 border-b border-gray-300">
     <app-search-input #searchbar (fetch_new_list)="get_list($event)"></app-search-input>
</div>
<app-ag-grid-list [list]="items" [colDefs]="transaction_history_cols" [itemName]="page_name" (fetch_new_list)="get_list($event)"></app-ag-grid-list>